import React, { useEffect, useState } from 'react'
import { injectIntl } from "react-intl";
import { useDispatch, useSelector } from 'react-redux';
import { deleteAttachmentRequest, editAttachmentRequest, getAttachmentsRequest } from '../../../store/attachments/actions';
import ConfirmDialog from "../../ConfirmDialog/ConfirmDialog";
import moment from 'moment';
import '../style.scss'
import { useParams } from 'react-router-dom';
import TableGridView from "../../../components/TableGridView";
import GetAppIcon from '@material-ui/icons/GetApp';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import EditIcon from '@material-ui/icons/Edit';
import CloseIcon from '@material-ui/icons/Close';
import CheckIcon from '@material-ui/icons/Check';
import { Tooltip } from '@material-ui/core';
import axios from 'axios';

function GeneralAttachments({ intl: { messages }, currentDate, patientId, disabled }) {
    const dispatch = useDispatch();
    const { attachments } = useSelector((state) => state.attachments);
    const { id } = useParams()
    const [editAttachmentName, setEditAttachmentName] = useState(false);
    const [attachmentName, setAttachmentName] = useState('');
    const [deleteConfirmation, setDeleteConfirmation] = useState(false);
    const [selectedAttachment, setSelectedAttachment] = useState(null);
    const lang = localStorage.getItem('lang');
    const token = useSelector((state) => state.auth?.token?.token) || localStorage.getItem("token");
    // const [loading, setloading] = useState(false);

    useEffect(() => {
            dispatch(getAttachmentsRequest({ patientId: id, sort: 'created_at,desc'}));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);
    
    //table n grid view render
  const headings = [
    messages.patients.attachments.filename,
    messages.patients.attachments.creation_date,
    messages.patients.attachments.created_by,
    messages.patients.attachments.actions,
  ];

   //for mime type you can also use any package
  const  GetMineType = (extension) =>{
    switch (extension.toLowerCase()) {
      case "pdf": return "application/pdf";
      case "jpb": return "application/octet-stream";
      case "jpe": return "image/jpeg";
      case "jpeg": return "image/jpeg";
      case "jpg": return "image/jpeg";
      case "png": return "image/png";
      default: return "application/octet-stream";
    }
  }

  function downloadBlob(blob, filename,ext) {
    // Create an object URL for the blob object
    console.info(GetMineType(ext));
    const url = URL.createObjectURL(new Blob([blob],{type: `${GetMineType(ext)}`}));
  
    // Create a new anchor element
    const a = document.createElement('a');
  
    // Set the href and download attributes for the anchor element
    // You can optionally set other attributes like `title`, etc
    // Especially, if the anchor element will be attached to the DOM
    a.href = url;
    a.download = filename || 'download';
  
    // Click handler that releases the object URL after the element has been clicked
    // This is required for one-off downloads of the blob content
    a.click();
  }

  const downloadFile = (id, name, ext) => {
       
    axios.get(`${process.env.REACT_APP_BASE_URL}/system/v1/attachments/${id}/download`, {
        responseType: 'arraybuffer',
        headers: {
          "Content-Type": "application/json",
          "Accept-Language": lang,
          Authorization: `Bearer ${token}`,
        },
    })
    .then((response) =>{
      if(response.status ===200){
          downloadBlob(response.data, name, ext);
      }else{
          alert('Error');
      }
      // setloading(false);
    }).catch(error =>console.log(error));
  }
  

  const renderTableData = () => {
    return attachments?.data?.map((attachment, i) => {
      const { name, uploaded_by, uploaded_at } = attachment;
      return [
        editAttachmentName && selectedAttachment === attachment.id
        ? <div className="name-edit">
            <input type="text" value={attachmentName} 
                    onChange={(e) => setAttachmentName(e.target.value)} 
                    onKeyDown={e => {
                      if (e.key === "Enter") {
                          setEditAttachmentName(false);
                          dispatch(editAttachmentRequest({
                            name: attachmentName,
                            id: attachment.id,
                          }));
                      }
                    }} 
                    /> 
            <CloseIcon onClick={() => {setEditAttachmentName(false); setSelectedAttachment(null)}} />
            <CheckIcon className="check-icon" onClick={() => {
                setSelectedAttachment(null);
                setEditAttachmentName(false);
                dispatch(editAttachmentRequest({
                  name: attachmentName,
                  id: attachment.id,
                }));
            }} />
          </div>
        : <span className='name-container'
                onDoubleClick={() => {
                  document.getElementById(`file-link${attachment.id}`).click();
                }} >
            <Tooltip title={name} placement="bottom" style={{ cursor: "pointer" }}>
              <span className="attachment_name">
                {name.length > 25 ? `${name.substring(0,30)}...` : name}
              </span>
            </Tooltip>
            <EditIcon onClick={() => {
                if (!disabled) {
                  setAttachmentName(name);
                  setSelectedAttachment(attachment.id);
                  setEditAttachmentName(true);
                }
                }} />
          </span>,
        moment(uploaded_at).format("dddd,\xa0 DD MMMM YYYY, h:mm a"),
        uploaded_by,
        <div className="table-actions">
          <DeleteForeverIcon className='delete-icon' onClick={() => {
              if (!disabled) {
                setSelectedAttachment(attachment.id);
                setDeleteConfirmation(true)
              }
            }} />
            {/* downloadFile(attachment.id, name, attachment.extension)}  */}
          <GetAppIcon className='download-icon' onClick={() => downloadFile(attachment.id, name, attachment.extension) }/>
          <a id={`file-link${attachment.id}`} href={`${process.env.REACT_APP_BASE_URL}${attachment.url}`} target="_blank" rel="noopener noreferrer">&nbsp;</a>
        </div>,
      ];
    });
  };
  
    const handlePageChange = (e, page) => {
        return dispatch(
            getAttachmentsRequest({
            page,
            patientId: id,
        })
        );
    };

    if (attachments?.data?.length > 0) {
      return (
          <div style={{ width: '100%' }} className='myscrollbar-container'>
              <TableGridView
                title={null}
                Form={null}
                table={{
                  stickyHeader: true,
                  headings: headings,
                  data: renderTableData(),
                  headClass: "bg-white table-head",
                  noData: messages.noData.no_data,
                }}
                pagination={{
                  count: attachments.last_page,
                  page: attachments.current_page,
                  handleChange: handlePageChange,
                }}
              />
            {/* <DialogComponent
              open={isOpen}
              handleClose={() => {
                setErrMsg("");
                setSelectedReasonObjValue({});
                setRejectionPayload(rejectionPayloadInitialize);
                setIsOpen(false);
              }}
              content={renderModalContent()}
            />
            */}
            <ConfirmDialog show={deleteConfirmation} 
                            onCancel={() => {
                              setDeleteConfirmation(false)
                            }}
                            onConfirm={() => {
                              dispatch(deleteAttachmentRequest(selectedAttachment))
                              setDeleteConfirmation(false);
                            }}
                            content={messages.patients.attachments.delete_confirmation}
                            cancelBtn={messages.warningMsgs.cancel}
                            confirmBtn={messages.warningMsgs.confirm} /> 
          </div>
      );
    } else {
      return (
        <div className="no-data-block">
            {messages.appointments.noAttachments}
        </div>
      )
    }
}

export default injectIntl(GeneralAttachments)